import { type LoaderFunctionArgs } from "react-router";

import {
  DashboardSkillsDetailsDocument,
  type DashboardSkillsDetailsQuery,
  type DashboardSkillsDetailsQueryVariables,
} from "@app_schema";

import { client } from "@application/config/apollo";

import { requireParam } from "@application/hooks/use_required_param";

export const DASHBOARD_SKILLS_DETAILS_LOADER = async (
  props: LoaderFunctionArgs,
) => {
  const { data } = await client.query<
    DashboardSkillsDetailsQuery,
    DashboardSkillsDetailsQueryVariables
  >({
    query: DashboardSkillsDetailsDocument,
    variables: { id: requireParam(props.params, "id") },
  });

  return data;
};
